'use client'

import { createContext, useContext, useState, ReactNode } from 'react'

interface ContentLayoutContextType {
  isExpanded: boolean
  toggleExpanded: () => void
  setExpanded: (expanded: boolean) => void
}

const ContentLayoutContext = createContext<ContentLayoutContextType | undefined>(undefined)

export function ContentLayoutProvider({ children }: { children: ReactNode }) {
  const [isExpanded, setIsExpanded] = useState(true)

  const toggleExpanded = () => {
    setIsExpanded((prev) => !prev)
  }

  const setExpanded = (expanded: boolean) => {
    setIsExpanded(expanded)
  }

  return (
    <ContentLayoutContext.Provider value={{ isExpanded, toggleExpanded, setExpanded }}>
      {children}
    </ContentLayoutContext.Provider>
  )
}

export function useContentLayout() {
  const context = useContext(ContentLayoutContext)
  if (context === undefined) {
    throw new Error('useContentLayout must be used within a ContentLayoutProvider')
  }
  return context
}


